@if (loading) {
  <app-loader></app-loader>
}
<div class="taskboard-1">
  <div class="row">
    <div class="col-12 col-sm-6">
      <app-dynamic-breadcrumb [bgColor]="'transparent'" [fontSize]="'14px'"
      [lastLinkColor]="'rgba(196, 196, 205, 0.42)'" [fontColor]="'#c4c4cd'"></app-dynamic-breadcrumb>
    </div>

    <div class="col-12 col-sm-6 mb-3 mb-xl-0">
      <div class="position-relative w-100 search-input-overall taskboard-search">
        <input type="text" name="nameFilter" [(ngModel)]="searchReport" placeholder="Search Report"
          class="w-100" />
          <i class="fas fa-search"></i>
        </div>
      </div>
    </div>
    <div class="row mt-lg-3 taskboard-division">
      <div class="col-12 d-xl-flex align-items-xl-center justify-content-xl-center">
        <div
          class="text-center mr-xl-5 mb-3 mb-xl-0 total-count d-flex flex-column align-items-center justify-content-center">
          <h5>{{totalReport}}</h5>
          <h6 class="mb-0">Total Reports (Weekly)</h6>
        </div>
        <div class="d-flex align-items-center justify-content-center date-wrapper">
          <p-datepicker ngbTooltip="Select a week" container="body" [showIcon]="true" appendTo="body"
            [(ngModel)]="viewScheduleDate" (onSelect)="scheduleDateChange(viewScheduleDate)" class="p-calendar-icon-only p-datepicker">
          </p-datepicker>
          <div class="disabled-date">
            {{(dateList?.length > 0 && isValidDate(dateList[0])) ? (dateList[0] | date:'dd') : ''}}
            {{(dateList?.length > 0 && isValidDate(dateList[0])) ? (dateList[0] | date:'MMM') : ''}}
          </div>
          <div class="enabled-date hvr-shrink" [ngClass]="activeDate1 == true ? 'active-date' : ''"
            (click)="getDateList(dateList[1],1)">
            {{(dateList?.length > 0 && isValidDate(dateList[1])) ? (dateList[1] | date:'dd') : ''}}
            {{(dateList?.length > 0 && isValidDate(dateList[1])) ? (dateList[1] | date:'MMM') : ''}}
          </div>
          <div class="enabled-date hvr-shrink" [ngClass]="activeDate2 == true ? 'active-date' : ''"
            (click)="getDateList(dateList[2],2)">
            {{(dateList?.length > 0 && isValidDate(dateList[2])) ? (dateList[2] | date:'dd') : ''}}
            {{(dateList?.length > 0 && isValidDate(dateList[2])) ? (dateList[2] | date:'MMM') : ''}}
          </div>
          <div class="enabled-date hvr-shrink" [ngClass]="activeDate3 == true ? 'active-date' : ''"
            (click)="getDateList(dateList[3],3)">
            {{(dateList?.length > 0 && isValidDate(dateList[3])) ? (dateList[3] | date:'dd') : ''}}
            {{(dateList?.length > 0 && isValidDate(dateList[3])) ? (dateList[3] | date:'MMM') : ''}}
          </div>
          <div class="enabled-date hvr-shrink" [ngClass]="activeDate4 == true ? 'active-date' : ''"
            (click)="getDateList(dateList[4],4)">
            {{(dateList?.length > 0 && isValidDate(dateList[4])) ? (dateList[4] | date:'dd') : ''}}
            {{(dateList?.length > 0 && isValidDate(dateList[4])) ? (dateList[4] | date:'MMM') : ''}}
          </div>
          <div class="enabled-date hvr-shrink" [ngClass]="activeDate5 == true ? 'active-date' : ''"
            (click)="getDateList(dateList[5],5)">
            {{(dateList?.length > 0 && isValidDate(dateList[5])) ? (dateList[5] | date:'dd') : ''}}
            {{(dateList?.length > 0 && isValidDate(dateList[5])) ? (dateList[5] | date:'MMM') : ''}}
          </div>
          <div class="disabled-date">
            {{(dateList?.length > 0 && isValidDate(dateList[6])) ? (dateList[6] | date:'dd') : ''}}
            {{(dateList?.length > 0 && isValidDate(dateList[6])) ? (dateList[6] | date:'MMM') : ''}}
          </div>
          <i class="fas fa-times-circle clear-date cursor-pointer" (click)="deactiveDateCircle()"
          ngbTooltip="Clear date selection" container="body"></i>
        </div>
        <div
          class="text-center ml-xl-5 mt-3 mt-xl-0 total-count d-flex flex-column align-items-center justify-content-center">
          <h5>{{totalReportInSelectedDate}}</h5>
          <h6 class="mb-0">{{'Total Reports ('+filterDate+')'}}</h6>
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-12">
        <div class="card suite-report-list">
          <div class="card-body list-body" data-simplebar data-simplebar-auto-hide="false">
            <div class="row flex-nowrap count-div">
              @for (report of filterReportSchedule | searchReportFilter:'ReportDisplayName':searchReport; track report) {
                <div class="col-xl-2 col-8 col-sm-5 col-md-4 col-lg-3"
                  >
                  <div class="card w-100 card-list mb-0"
                    [ngClass]="{'active-report':report.IsReportSelected == true, 'mapped-card':report.ReportPackName != null, 'unmapped-card':report.ReportPackName == null}"
                    (click)="getReportApprovalLevel(report,0)">
                    <div class="card-header">
                      <div class="d-flex flex-column align-items-center justify-content-center">
                        <span>
                          {{report.SuiteName}} | <span class="report-highlight">
                          {{report.ReportDisplayName}}
                        </span>
                      </span>
                      <span class="support-text">Suite | Report</span>
                    </div>
                  </div>
                  <div
                    class="card-body d-flex flex-column align-items-center justify-content-center text-center">
                    <div class="d-flex flex-column align-items-center justify-content-center mb-2">
                      <span>{{report.FallDate ? (report.FallDate | date: 'dd/MM/yyyy') : 'N/A'}}</span>
                      <span class="support-text">Report Due Date</span>
                    </div>
                    <!-- <div class="d-flex flex-column align-items-center justify-content-center">
                    <span>3 | 5</span>
                    <span class="support-text">Current | Max (Approval Level)</span>
                  </div> -->
                </div>
                <div class="card-footer text-center">
                  <div class="h-100 pr-2" data-simplebar data-simplebar-auto-hide="false">
                    @if (report.ReportPackName != null) {
                      <i>
                        Report mapped to
                        '{{report.ReportPackName}}'
                      </i>
                    }
                    @if (report.ReportPackName == null) {
                      <i>
                        Please map
                        to a
                        report pack
                      </i>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="row mb-3">
<div class="col-12">
  <div class="d-flex align-items-center filter-wrapper">
    <div class="filter-wrapper-content d-flex align-items-center justify-content-center" *ngIf="selectedRp">
      <div class="col-12 specify-overflow" id="overflowCheck">
        <span class="value mr-3">
          <span class="title">Report Pack Title | </span>{{selectedRp.Title}}</span>
          <span class="value mr-3">
            <span class="title">Report Date |
            </span>{{selectedRp.ReportDate | date: 'dd/MM/yyyy'}}</span>
            <span class="value">
              <span class="title">Description | </span><span
            *ngIf="selectedRp.RP_Description != null">{{selectedRp.RP_Description}}</span><span
          *ngIf="selectedRp.RP_Description == null">No description provided</span></span>
        </div>
      </div>
    </div>
  </div>
</div> -->

<div class="row mb-3">
  <div class="col-12">
    <app-report-pack-filter [selectedReportPacks]="selectedRp"></app-report-pack-filter>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="scrollable-taskboard-table">
      <p-table #taskBoardList [value]="reportApprovalList" [paginator]="true" [rows]="4" scrollable="true" scrollHeight="calc(100vh - 400px)"
        class="table-irr data-scheduler" [columns]="headerCols">
        <ng-template pTemplate="paginatorleft">
          <button class="btn btn-clear-filter hvr-shrink" type="button"
            (click)="taskBoardList.reset();clearFilters();">
            <span><i class="fas fa-times mr-1"></i> Clear Filters</span>
          </button>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            @for (col of columns; track col) {
              <th [pSortableColumn]="col.field">
                {{col.header}}
                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                  ariaLabelDesc="Activate to sort in descending order"
                  ariaLabelAsc="Activate to sort in ascending order">
                </p-sortIcon>
              </th>
            }
            <th>Actions</th>
          </tr>
          <tr>
            @for (col of columns; track col) {
              <th>
                @if (col.field =='appDate') {
                  <p-datepicker [(ngModel)]="reportDateFilters"
                    selectionMode="range" [showIcon]="true" dateFormat="dd/mm/yy" [readonlyInput]="true"
                    placeholder="Select a range" [monthNavigator]="true"
                    [yearNavigator]="true" yearRange="{{yearRange}}" appendTo="body"
                    (ngModelChange)="taskBoardList.filter(reportDateFilters, col.field, 'dateRangeFilter')">
                  </p-datepicker>
                }
                @if (col.field !='appDate') {
                  <input type="text" class="w-100" placeholder="Filter Text"
                    [value]="taskBoardList.filters && taskBoardList.filters[col.field] ? taskBoardList.filters[col.field].value: ''"
                    (input)="taskBoardList.filter($event.target.value, col.field, 'contains')">
                }
              </th>
            }
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
          <tr>
            <td>{{rowData.ApprovalLevelDesc}}</td>
            <td>{{rowData.UserName}}</td>
            <td>{{rowData.ApprovalDate ? (rowData.ApprovalDate | date:'dd/MM/yyyy') : 'N/A'}}</td>
            <td>{{rowData.comment}}</td>
            <td>
              <!-- @if ((!rowData.ApprovalDate || rowData.ApprovalDate === '') && rowData.UserName !== loginUser?.username && rowData.hasPermission) {
                <button class="btn-table-icon hvr-shrink ml-2" ngbTooltip="Assign to me"
                  id='assignReportToMe'
                  (click)="assignReportToMe(rowData)" container="body" type="button">
                  <i class="fas fa-user-check fa-lg"></i>
                </button>
              }
              @if ((!rowData.ApprovalDate || rowData.ApprovalDate === '') && rowData.UserName === loginUser?.username && rowData.hasPermission) {
                <button class="btn-table-icon hvr-shrink ml-2" ngbTooltip="Release From me"
                  id='releaseReportFromMe'
                  (click)="releaseReportFromMe(rowData)" container="body" type="button">
                  <i class="fas fa-user-times fa-lg"></i>
                </button>
              } -->
              <button class="btn-table-icon hvr-shrink ml-2" ngbTooltip="View report" id='viewReprot'
                (click)="gotoReport(rowData)" container="body" type="button">
                <i class="fas fa-eye fa-lg"></i>
              </button>

            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
</div>